import React, { useMemo } from 'react';
import * as Diff from 'diff';
import './PromptEditor.css';

/** Word-level diff for display (not character or whitespace-token level). */
export function computeWordDiffParts(oldText = '', newText = '') {
  return Diff.diffWords(oldText || '', newText || '');
}

/**
 * Word-level inline diff. Always computes client-side word diff for consistent display.
 */
export default function PromptDiffView({ oldText = '', newText = '', parts = null, className = '' }) {
  const diffParts = useMemo(
    () => computeWordDiffParts(oldText, newText),
    [oldText, newText, parts],
  );

  return (
    <div className={`prompt-diff-view ${className}`}>
      {diffParts.map((part, i) => {
        if (part.added) {
          return (
            <span key={i} className="prompt-diff-insert">
              {part.value}
            </span>
          );
        }
        if (part.removed) {
          return (
            <span key={i} className="prompt-diff-delete">
              {part.value}
            </span>
          );
        }
        return <span key={i}>{part.value}</span>;
      })}
    </div>
  );
}
